module.exports = __webpack_public_path__ + "static/media/wave.75ead9cc.svg";